/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import {
  ApplyDirectoryRoleSetupRole,
  ApplyDirectoryRoleSetupRole$Outbound,
  ApplyDirectoryRoleSetupRole$outboundSchema,
} from "./applydirectoryrolesetuprole.js";
import {
  DirectoryRoleSetupSource,
  DirectoryRoleSetupSource$Outbound,
  DirectoryRoleSetupSource$outboundSchema,
} from "./directoryrolesetupsource.js";

export type ApplyDirectoryRoleSetupItem = {
  /**
   * The complete role set for the source. Empty removes every mapping for the source.
   */
  roles: Array<ApplyDirectoryRoleSetupRole>;
  source: DirectoryRoleSetupSource;
  /**
   * The item version from previewDirectoryRoleSetup.
   */
  version: string;
};

/** @internal */
export type ApplyDirectoryRoleSetupItem$Outbound = {
  roles: Array<ApplyDirectoryRoleSetupRole$Outbound>;
  source: DirectoryRoleSetupSource$Outbound;
  version: string;
};

/** @internal */
export const ApplyDirectoryRoleSetupItem$outboundSchema: z.ZodMiniType<
  ApplyDirectoryRoleSetupItem$Outbound,
  ApplyDirectoryRoleSetupItem
> = z.object({
  roles: z.array(ApplyDirectoryRoleSetupRole$outboundSchema),
  source: DirectoryRoleSetupSource$outboundSchema,
  version: z.string(),
});

export function applyDirectoryRoleSetupItemToJSON(
  applyDirectoryRoleSetupItem: ApplyDirectoryRoleSetupItem,
): string {
  return JSON.stringify(
    ApplyDirectoryRoleSetupItem$outboundSchema.parse(
      applyDirectoryRoleSetupItem,
    ),
  );
}
